"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5095],{

/***/ 15825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64857);
/* harmony import */ var _dga_checkbox_input_DGACheckboxInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4145);
/* harmony import */ var _icons_arrow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18106);
/* harmony import */ var lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78341);
/* harmony import */ var _isRtl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62009);







var ChechIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.265 5.4649C16.5146 5.70323 16.5238 6.09885 16.2855 6.34854L7.53551 15.5152C7.41932 15.6369 7.25895 15.7067 7.09068 15.7086C6.92241 15.7106 6.76046 15.6446 6.64147 15.5256L3.72481 12.6089C3.48073 12.3649 3.48073 11.9691 3.72481 11.7251C3.96888 11.481 4.36461 11.481 4.60869 11.7251L7.07302 14.1894L15.3813 5.48545C15.6197 5.23576 16.0153 5.22656 16.265 5.4649Z",
            fill: "#161616"
        })
    });
};
var DGADropdownInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var _options = param.options, options = _options === void 0 ? [] : _options, value = param.value, onChange = param.onChange, _multiple = param.multiple, multiple = _multiple === void 0 ? false : _multiple, _emptyText = param.emptyText, emptyText = _emptyText === void 0 ? "No options available" : _emptyText, _closeAfterSelect = param.closeAfterSelect, closeAfterSelect = _closeAfterSelect === void 0 ? false : _closeAfterSelect, maxHeight = param.maxHeight, renderOption = param.renderOption, singleSelectIcon = param.singleSelectIcon, startIcon = param.startIcon, endIcon = param.endIcon, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, _InputSize = param.InputSize, InputSize = _InputSize === void 0 ? "lg" : _InputSize, _LabelSize = param.LabelSize, LabelSize = _LabelSize === void 0 ? "md" : _LabelSize, _LabelWeight = param.LabelWeight, LabelWeight = _LabelWeight === void 0 ? "regular" : _LabelWeight, label = param.label, name = param.name, _error = param.error, error = _error === void 0 ? false : _error, errorMessage = param.errorMessage, helperText = param.helperText, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _required = param.required, required = _required === void 0 ? false : _required, requiredIndicator = param.requiredIndicator, _dropdownClassName = param.dropdownClassName, dropdownClassName = _dropdownClassName === void 0 ? "" : _dropdownClassName, _optionClassName = param.optionClassName, optionClassName = _optionClassName === void 0 ? "" : _optionClassName, _customDisplayValue = param.customDisplayValue, customDisplayValue = _customDisplayValue === void 0 ? undefined : _customDisplayValue, _mainDropdownContainerClassName = param.mainDropdownContainerClassName, mainDropdownContainerClassName = _mainDropdownContainerClassName === void 0 ? "" : _mainDropdownContainerClassName, _containerClassName = param.containerClassName, containerClassName = _containerClassName === void 0 ? "" : _containerClassName, _inputWrapperClassName = param.inputWrapperClassName, inputWrapperClassName = _inputWrapperClassName === void 0 ? "" : _inputWrapperClassName, _inputClassName = param.inputClassName, inputClassName = _inputClassName === void 0 ? "" : _inputClassName, _labelClassName = param.labelClassName, labelClassName = _labelClassName === void 0 ? "" : _labelClassName, _errorClassName = param.errorClassName, errorClassName = _errorClassName === void 0 ? "" : _errorClassName, _helperTextClassName = param.helperTextClassName, helperTextClassName = _helperTextClassName === void 0 ? "" : _helperTextClassName, placeholder = param.placeholder;
    var size = lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_4__/* .sizeMap */ .dG[InputSize];
    var labelSize = "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_4__/* .LabelSizeMap */ .V7[LabelSize], " ").concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_4__/* .LabelSizeMap */ .V7[LabelWeight]);
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var normalizedValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (multiple) {
            return Array.isArray(value) ? value : value !== undefined ? [
                value
            ] : [];
        }
        return Array.isArray(value) ? value[0] : value;
    }, [
        value,
        multiple
    ]);
    var displayValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (customDisplayValue) return customDisplayValue;
        if (multiple) {
            var selectedOptions = options === null || options === void 0 ? void 0 : options.filter(function(option) {
                return Array.isArray(normalizedValue) && (normalizedValue === null || normalizedValue === void 0 ? void 0 : normalizedValue.includes(option === null || option === void 0 ? void 0 : option.value));
            });
            return (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0 ? selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function(option) {
                return option === null || option === void 0 ? void 0 : option.label;
            }).join(", ") : placeholder;
        } else {
            var selectedOption = options === null || options === void 0 ? void 0 : options.find(function(option) {
                return option.value === normalizedValue;
            });
            return selectedOption ? selectedOption.label : placeholder;
        }
    }, [
        normalizedValue,
        options,
        multiple,
        customDisplayValue,
        placeholder
    ]);
    var isShowingPlaceholder = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (customDisplayValue) return false;
        if (!placeholder) return false;
        if (multiple) {
            return !Array.isArray(normalizedValue) || normalizedValue.length === 0;
        }
        return normalizedValue === undefined || normalizedValue === null || normalizedValue === "";
    }, [
        customDisplayValue,
        multiple,
        normalizedValue,
        placeholder
    ]);
    var selectedOption = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (multiple) {
            return options === null || options === void 0 ? void 0 : options.filter(function(option) {
                return Array.isArray(normalizedValue) && (normalizedValue === null || normalizedValue === void 0 ? void 0 : normalizedValue.includes(option === null || option === void 0 ? void 0 : option.value));
            });
        } else {
            return options === null || options === void 0 ? void 0 : options.find(function(option) {
                return (option === null || option === void 0 ? void 0 : option.value) === normalizedValue;
            });
        }
    }, [
        normalizedValue,
        options,
        multiple
    ]);
    var handleOptionChange = function(option) {
        if (multiple && Array.isArray(option)) {
            var ref;
            var newValues = option === null || option === void 0 ? void 0 : option.map(function(opt) {
                return opt === null || opt === void 0 ? void 0 : opt.value;
            });
            onChange === null || onChange === void 0 ? void 0 : onChange(newValues);
            if (!closeAfterSelect) buttonRef === null || buttonRef === void 0 ? void 0 : (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.click();
        } else if (!multiple && !Array.isArray(option)) {
            var ref1;
            var isCurrentlySelected = normalizedValue === (option === null || option === void 0 ? void 0 : option.value);
            var newValue = isCurrentlySelected ? undefined : option === null || option === void 0 ? void 0 : option.value;
            onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
            if (!closeAfterSelect) buttonRef === null || buttonRef === void 0 ? void 0 : (ref1 = buttonRef.current) === null || ref1 === void 0 ? void 0 : ref1.click();
        }
    };
    var isOptionSelected = function(option) {
        if (multiple) {
            return Array.isArray(normalizedValue) && normalizedValue.includes(option === null || option === void 0 ? void 0 : option.value);
        }
        return normalizedValue === (option === null || option === void 0 ? void 0 : option.value);
    };
    var renderOptionContent = function(option, isSelected) {
        if (renderOption) return renderOption(option, isSelected);
        var ref;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center gap-2 w-full p-2",
            children: [
                multiple && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dga_checkbox_input_DGACheckboxInput__WEBPACK_IMPORTED_MODULE_2__.DGACheckboxInput, {
                    size: "xs",
                    variant: "default",
                    checked: isSelected,
                    "aria-label": String((ref = option === null || option === void 0 ? void 0 : option.label) !== null && ref !== void 0 ? ref : "")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    title: option === null || option === void 0 ? void 0 : option.label,
                    className: "flex-1 text-start rtl:text-right line-clamp-1",
                    children: option === null || option === void 0 ? void 0 : option.label
                }),
                !multiple && isSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "flex-shrink-0 w-5 h-5 flex items-center justify-center",
                    children: singleSelectIcon || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChechIcon, {})
                })
            ]
        });
    };
    var wrapperClasses = (0,lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_4__/* .getWrapperClasses */ .x6)("dropdown", variant, error, disabled, startIcon, true, inputWrapperClassName);
    var finalInputClasses = "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_4__/* .baseClasses.inputBase */ ._L.inputBase(size, false, disabled), " ").concat(inputClassName).trim();
    var finalLabelClasses = "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_4__/* .baseClasses.labelBase */ ._L.labelBase(disabled, labelSize), " ").concat(labelClassName).trim();
    var finalErrorClasses = "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_4__/* .baseClasses.errorBase */ ._L.errorBase, " ").concat(errorClassName).trim();
    var finalDescriptionClasses = "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_4__/* .baseClasses.descriptionBase */ ._L.descriptionBase, " ").concat(helperTextClassName).trim();
    var finalContainerClasses = "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_4__/* .baseClasses.containerBase */ ._L.containerBase, " ").concat(containerClassName).trim();
    var handleLabelClick = function() {
        if (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) {
            var isOpen = (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current.getAttribute("aria-expanded")) === "true";
            if (!isOpen) {
                buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current.click();
            } else {
                buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current.blur();
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        dir: (0,_isRtl__WEBPACK_IMPORTED_MODULE_5__["default"])() ? "rtl" : "ltr",
        className: "".concat(finalContainerClasses, " ").concat(mainDropdownContainerClassName),
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: finalLabelClasses,
                onClick: handleLabelClick,
                children: [
                    label,
                    required && (requiredIndicator || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-red-500",
                        children: "*"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Listbox */ .R, {
                value: selectedOption,
                onChange: handleOptionChange,
                multiple: multiple,
                disabled: disabled,
                name: name,
                children: function(param) {
                    var open = param.open;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative w-full min-w-[200px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Listbox.Button */ .R.Button, {
                                ref: function(node) {
                                    buttonRef.current = node;
                                    if (typeof ref === "function") ref(node);
                                    else if (ref) ref.current = node;
                                },
                                className: "".concat(wrapperClasses, " cursor-pointer focus-within:border-transparent focus-within:before:scale-x-0 before:transition-transform before:scale-x-0 ").concat(open ? "!bg-white ".concat(error ? "" : "!border-neutral-400", " before:scale-x-100 ") : variant === "Filled-Darker" ? "!bg-neutral-100 ".concat(error ? "" : "hover:!border-neutral-400 !border-transparent") : ""),
                                children: [
                                    startIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex-shrink-0 flex items-center justify-center",
                                        children: startIcon
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "".concat(finalInputClasses, " ").concat(isShowingPlaceholder ? "!text-neutral-500" : "").trim(),
                                        children: displayValue || placeholder
                                    }),
                                    (endIcon || !startIcon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex-shrink-0 flex items-center justify-center",
                                        children: endIcon || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "transition-transform duration-200 ".concat(open ? "rotate-180" : "rotate-0"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_arrow__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                                fill: disabled ? "#9DA4AE" : "#000000",
                                                "aria-label": "",
                                                "aria-hidden": true
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Listbox.Options */ .R.Options, {
                                dir: (0,_isRtl__WEBPACK_IMPORTED_MODULE_5__["default"])() ? "rtl" : "ltr",
                                className: "\n                                absolute top-full left-0 rtl:left-auto rtl:right-0 z-50 w-full min-w-[200px] bg-white border border-neutral-300 rounded-md shadow-lg p-2 mt-1\n\n                                focus-within:outline-none\n                                overflow-y-auto\n                                ".concat(dropdownClassName, "\n                            "),
                                style: {
                                    boxShadow: "0px 20px 24px -4px #10182814",
                                    maxHeight: maxHeight ? "".concat(maxHeight, "px") : "300px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "overflow-y-auto space-y-0.5",
                                    children: (options === null || options === void 0 ? void 0 : options.length) === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-neutral-500 text-center p-2",
                                        children: emptyText
                                    }) : options === null || options === void 0 ? void 0 : options.map(function(option) {
                                        var isSelected = isOptionSelected(option);
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Listbox.Option */ .R.Option, {
                                            value: option,
                                            disabled: option === null || option === void 0 ? void 0 : option.disabled,
                                            className: function(param) {
                                                var active = param.active;
                                                return "\n                                                    cursor-pointer transition-colors rounded w-full\n                                                    bg-white hover:bg-neutral-100 active:bg-neutral-200 \n                                                    focus:bg-white\n                                                    border-2 border-transparent focus:!border-primary-1000 focus:!outline-none\n                                                    ".concat(isSelected && "bg-neutral-200", "\n                                                    ").concat((option === null || option === void 0 ? void 0 : option.disabled) ? "opacity-50 cursor-not-allowed" : "", "\n                                                    ").concat(active ? "bg-neutral-100" : "", "\n                                                    ").concat(optionClassName, "\n                                                ");
                                            },
                                            children: renderOptionContent(option, isSelected)
                                        }, option === null || option === void 0 ? void 0 : option.value);
                                    })
                                })
                            })
                        ]
                    });
                }
            }),
            helperText && !error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: finalDescriptionClasses,
                children: helperText
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: finalErrorClasses,
                children: errorMessage
            })
        ]
    });
});
DGADropdownInput.displayName = "DGADropdownInput";
/* harmony default export */ __webpack_exports__["default"] = (DGADropdownInput);


/***/ }),

/***/ 130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78341);






/**
 * DGAInput Component
 *
 * @param {string | React.ReactNode} label - Input label
 * @param {string} labelClassName - Custom class for label
 * @param {string} containerClassName - Custom class for outer container
 * @param {string} inputWrapperClassName - Custom class for input wrapper
 * @param {boolean} error - Show error state
 * @param {boolean | React.ReactNode} errorMessage - Error message
 * @param {string} errorClassName - Custom class for error text
 * @param {ReactNode} startIcon - Icon before input
 * @param {ReactNode} endIcon - Icon after input
 * @param {string | React.ReactNode} helperText - Helper/description text
 * @param {string} helperTextClassName - Custom class for helper text
 * @param {string} inputClassName - Custom class for input element
 * @param {ReactNode} requiredIndicator - Custom indicator for required fields
 * @param {'md' | 'lg'} InputSize - Input size variant
 * @param {'md' | 'lg'} LabelSize - Label size variant
 * @param {'regular' | 'semibold'} LabelWeight - Label font weight
 * @param {'default' | 'Filled-Darker' | 'Filled-Lighter'} variant - Style variant
 */ var DGAInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var label = _param.label, _labelClassName = _param.labelClassName, labelClassName = _labelClassName === void 0 ? "" : _labelClassName, _containerClassName = _param.containerClassName, containerClassName = _containerClassName === void 0 ? "" : _containerClassName, _inputWrapperClassName = _param.inputWrapperClassName, inputWrapperClassName = _inputWrapperClassName === void 0 ? "" : _inputWrapperClassName, error = _param.error, errorMessage = _param.errorMessage, _errorClassName = _param.errorClassName, errorClassName = _errorClassName === void 0 ? "" : _errorClassName, startIcon = _param.startIcon, endIcon = _param.endIcon, helperText = _param.helperText, _helperTextClassName = _param.helperTextClassName, helperTextClassName = _helperTextClassName === void 0 ? "" : _helperTextClassName, _inputClassName = _param.inputClassName, inputClassName = _inputClassName === void 0 ? "" : _inputClassName, requiredIndicator = _param.requiredIndicator, _InputSize = _param.InputSize, InputSize = _InputSize === void 0 ? "lg" : _InputSize, _LabelSize = _param.LabelSize, LabelSize = _LabelSize === void 0 ? "md" : _LabelSize, _LabelWeight = _param.LabelWeight, LabelWeight = _LabelWeight === void 0 ? "regular" : _LabelWeight, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, inputProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "label",
        "labelClassName",
        "containerClassName",
        "inputWrapperClassName",
        "error",
        "errorMessage",
        "errorClassName",
        "startIcon",
        "endIcon",
        "helperText",
        "helperTextClassName",
        "inputClassName",
        "requiredIndicator",
        "InputSize",
        "LabelSize",
        "LabelWeight",
        "variant"
    ]);
    var inputId = (inputProps === null || inputProps === void 0 ? void 0 : inputProps.id) || "input-".concat(inputProps === null || inputProps === void 0 ? void 0 : inputProps.name) || 0;
    // Adjust label size/weight dynamically
    var size = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_2__/* .sizeMap */ .dG[InputSize]), {
        label: "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_2__/* .LabelSizeMap */ .V7[LabelSize], " ").concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_2__/* .LabelSizeMap */ .V7[LabelWeight])
    });
    // Shared wrapper classes
    var wrapperClasses = (0,lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_2__/* .getWrapperClasses */ .x6)("input", variant, error, inputProps.disabled, startIcon, endIcon, inputWrapperClassName, inputProps === null || inputProps === void 0 ? void 0 : inputProps.readOnly);
    // Shared bases
    var finalInputClasses = "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_2__/* .baseClasses.inputBase */ ._L.inputBase(size, inputProps === null || inputProps === void 0 ? void 0 : inputProps.readOnly, inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled), " ").concat(inputClassName).trim();
    var finalLabelClasses = "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_2__/* .baseClasses.labelBase */ ._L.labelBase(inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled, size.label), " ").concat(labelClassName).trim();
    var finalErrorClasses = "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_2__/* .baseClasses.errorBase */ ._L.errorBase, " ").concat(errorClassName).trim();
    var finalHelperTextClasses = "".concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_2__/* .baseClasses.descriptionBase */ ._L.descriptionBase, " ").concat(helperTextClassName).trim();
    var finalContainerClasses = "".concat((inputProps === null || inputProps === void 0 ? void 0 : inputProps.readOnly) ? "!pointer-events-none" : "", " ").concat(lib_dga_input_components_variants_dga_inputs_variants__WEBPACK_IMPORTED_MODULE_2__/* .baseClasses.containerBase */ ._L.containerBase, " ").concat(containerClassName).trim();
    var handleFocusOnInputField = function() {
        var _$ref;
        var inputElement = document === null || document === void 0 ? void 0 : (_$ref = document.getElementById) === null || _$ref === void 0 ? void 0 : _$ref.call(document, inputId);
        if (inputElement) {
            inputElement.focus();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: finalContainerClasses,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: (inputProps === null || inputProps === void 0 ? void 0 : inputProps.id) || inputId,
                className: finalLabelClasses,
                children: [
                    label,
                    (inputProps === null || inputProps === void 0 ? void 0 : inputProps.required) && (requiredIndicator || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "".concat(inputProps.disabled ? "text-neutral-400" : "text-[#B42318]"),
                        children: "*"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: handleFocusOnInputField,
                className: wrapperClasses,
                children: [
                    startIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-shrink-0 text-gray-400 flex items-center justify-center",
                        children: startIcon
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        ref: ref,
                        id: inputId,
                        name: inputProps === null || inputProps === void 0 ? void 0 : inputProps.name,
                        required: inputProps === null || inputProps === void 0 ? void 0 : inputProps.required,
                        className: finalInputClasses
                    }, inputProps)),
                    endIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-shrink-0 text-gray-400 flex items-center justify-center",
                        children: endIcon
                    })
                ]
            }),
            helperText && !error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: finalHelperTextClasses,
                children: helperText
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: finalErrorClasses,
                role: "alert",
                children: errorMessage
            })
        ]
    });
});
DGAInput.displayName = "DGAInput";
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(DGAInput));


/***/ }),

/***/ 90244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




/**
 * TextArea component to render a styled and accessible textarea with label, validation, variants, and RTL support.
 *
 * @param {string} id - Unique identifier for the textarea field.
 * @param {string} name - Name attribute for the textarea element.
 * @param {string} [placeholder] - Placeholder text for the textarea.
 * @param {string} [label] - Optional label displayed above the textarea.
 * @param {string} [value] - The current value of the textarea.
 * @param {(e: React.ChangeEvent<HTMLTextAreaElement>) => void} [onChange] - Change handler for the textarea.
 * @param {(e: React.FocusEvent<HTMLTextAreaElement>) => void} [onBlur] - Blur handler for the textarea.
 * @param {boolean} [required=false] - Whether the field is required.
 * @param {React.ReactNode} [requiredIndicator] - Custom React node to render as the required asterisk. Defaults to a red "*".
 * @param {boolean} [error] - Whether the field has an error state.
 * @param {boolean | React.ReactNode} [errorMessage] - Optional error message to display below the textarea.
 * @param {number} [rows=3] - Number of visible text lines for the textarea.
 * @param {'none' | 'vertical' | 'horizontal' | 'both'} [resize='vertical'] - Controls textarea resize behavior.
 * @param {SizeVariant} [TextAreaSize='lg'] - Size variant for the textarea.
 * @param {SizeVariant} [LabelSize='md'] - Size variant for the label.
 * @param {WeightVariant} [LabelWeight='regular'] - Weight variant for the label.
 * @param {Variant} [variant='default'] - Style variant for the textarea.
 * @param {string} [dir] - Directionality ("ltr" or "rtl"), for layout and text alignment.
 */ var DGATextArea = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var getWrapperClasses = // Helper to get wrapper classes by variant and state
    function getWrapperClasses(variant, error, disabled, textareaWrapperClassName) {
        var base = "\n            relative group cursor-text flex flex-row rtl:flex-row-reverse items-start w-full rounded\n            transition-colors overflow-hidden\n            before:absolute before:!-bottom-[1px] before:left-1/2 before:translate-x-[-50%]\n            before:w-full before:!h-[3px] before:scale-x-0 before:origin-center before:transition-transform before:duration-300\n            focus-within:before:scale-x-100\n            ".concat((textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.readOnly) ? "!border-neutral-400 !bg-transparent" : "", "\n        ").replace(/\s+/g, " ").trim();
        var variants = {
            default: "\n                border ".concat(error ? "!border-[#B42318]" : "border-neutral-400", "\n                hover:border-neutral-700\n                focus-within:").concat(error ? "!border-[#B42318]" : "border-neutral-400", "\n                active:bg-neutral-100 active:border-neutral-400\n                ").concat(error ? "before:bg-[#B42318]" : "before:bg-neutral-950", "\n                ").concat(disabled ? "!border-neutral-300 !pointer-events-none" : "", "\n            ").replace(/\s+/g, " ").trim(),
            "Filled-Darker": "\n                border ".concat(error ? "!border-[#B42318]" : "border-transparent", "\n                hover:border-neutral-400\n                bg-neutral-100\n                active:bg-neutral-100\n                active:!border-neutral-400\n                focus-within:bg-transparent\n                ").concat(error ? "focus-within:!border-[#B42318]" : "focus-within:!border-neutral-400", "\n                ").concat(error ? "before:bg-[#B42318]" : "before:bg-neutral-950", "\n                ").concat(disabled || (textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.readOnly) ? "!border-neutral-300 !pointer-events-none !bg-transparent" : "", "\n            ").replace(/\s+/g, " ").trim(),
            "Filled-Lighter": "\n                border ".concat(error ? "!border-[#B42318]" : "border-transparent", "\n                hover:border-neutral-400\n                bg-transparent\n                active:bg-neutral-100\n                active:!border-neutral-300\n                focus-within:bg-transparent\n                ").concat(error ? "focus-within:!border-[#B42318]" : "focus-within:!border-neutral-400", "\n                ").concat(error ? "before:bg-[#B42318]" : "before:bg-neutral-950", "\n                ").concat(disabled || (textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.readOnly) ? "!border-neutral-300 !pointer-events-none !bg-transparent" : "", "\n            ").replace(/\s+/g, " ").trim()
        };
        return "".concat(base, " ").concat(variants[variant], " ").concat(textareaWrapperClassName).trim();
    };
    var label = _param.label, _labelClassName = _param.labelClassName, labelClassName = _labelClassName === void 0 ? "" : _labelClassName, _containerClassName = _param.containerClassName, containerClassName = _containerClassName === void 0 ? "" : _containerClassName, _textareaWrapperClassName = _param.textareaWrapperClassName, textareaWrapperClassName = _textareaWrapperClassName === void 0 ? "" : _textareaWrapperClassName, error = _param.error, errorMessage = _param.errorMessage, _errorClassName = _param.errorClassName, errorClassName = _errorClassName === void 0 ? "" : _errorClassName, description = _param.description, _descriptionClassName = _param.descriptionClassName, descriptionClassName = _descriptionClassName === void 0 ? "" : _descriptionClassName, _textareaClassName = _param.textareaClassName, textareaClassName = _textareaClassName === void 0 ? "" : _textareaClassName, _required = _param.required, required = _required === void 0 ? false : _required, requiredIndicator = _param.requiredIndicator, _resize = _param.resize, resize = _resize === void 0 ? "vertical" : _resize, _rows = _param.rows, rows = _rows === void 0 ? 3 : _rows, _TextAreaSize = _param.TextAreaSize, TextAreaSize = _TextAreaSize === void 0 ? "lg" : _TextAreaSize, _LabelSize = _param.LabelSize, LabelSize = _LabelSize === void 0 ? "md" : _LabelSize, _LabelWeight = _param.LabelWeight, LabelWeight = _LabelWeight === void 0 ? "regular" : _LabelWeight, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, id = _param.id, name = _param.name, textareaProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "label",
        "labelClassName",
        "containerClassName",
        "textareaWrapperClassName",
        "error",
        "errorMessage",
        "errorClassName",
        "description",
        "descriptionClassName",
        "textareaClassName",
        "required",
        "requiredIndicator",
        "resize",
        "rows",
        "TextAreaSize",
        "LabelSize",
        "LabelWeight",
        "variant",
        "id",
        "name"
    ]);
    var textareaId = id || "textarea-".concat(name) || 0;
    var LabelSizeMap = {
        md: "text-sm",
        lg: "text-base",
        regular: "font-normal",
        semibold: "font-semibold"
    };
    // Resize classes mapping
    var resizeMap = {
        none: "resize-none",
        vertical: "resize-y",
        horizontal: "resize-x",
        both: "resize"
    };
    // Size variant configs
    var sizeMap = {
        md: {
            padding: "px-2 py-1.5",
            font: "text-sm",
            label: "".concat(LabelSizeMap[LabelSize], " ").concat(LabelSizeMap[LabelWeight]),
            gap: "gap-1"
        },
        lg: {
            padding: "px-4 py-3",
            font: "text-base",
            label: "".concat(LabelSizeMap[LabelSize], " ").concat(LabelSizeMap[LabelWeight]),
            gap: "gap-2"
        }
    };
    var size = sizeMap[TextAreaSize];
    var wrapperClasses = getWrapperClasses(variant, error, textareaProps.disabled, textareaWrapperClassName);
    var textareaBase = "\n        w-full bg-transparent text-neutral-700 group-hover:text-primary-1000 outline-none border-none text-left rtl:!text-right\n        placeholder:!text-neutral-500 transition-colors flex-1 ".concat(size.font, " ").concat(resizeMap[resize], "\n        ").concat(textareaProps.readOnly ? "!text-primary-1000 !pointer-events-none" : "", "\n        ").concat(textareaProps.disabled ? "!text-neutral-400 placeholder:!text-neutral-400 !cursor-not-allowed" : "", "\n        ").concat(size.padding, " ").concat(size.gap, "\n    ").replace(/\s+/g, " ").trim();
    var labelBase = "".concat(textareaProps.disabled ? "text-neutral-400" : "text-primary-1000", " ").concat(size.label).trim();
    var errorBase = "text-sm text-red-600".trim();
    var descriptionBase = "text-sm text-gray-500".trim();
    var containerBase = "peer flex flex-col items-start w-full gap-2".trim();
    var finalTextAreaClasses = "".concat(textareaBase, " ").concat(textareaClassName).trim();
    var finalLabelClasses = "".concat(labelBase, " ").concat(labelClassName).trim();
    var finalErrorClasses = "".concat(errorBase, " ").concat(errorClassName).trim();
    var finalDescriptionClasses = "".concat(descriptionBase, " ").concat(descriptionClassName).trim();
    var finalContainerClasses = "".concat((textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.readOnly) ? "!pointer-events-none" : "", " ").concat(containerBase, " ").concat(containerClassName).trim();
    var handleFocusOnTextAreaField = function() {
        var _$ref;
        var textareaElement = document === null || document === void 0 ? void 0 : (_$ref = document.getElementById) === null || _$ref === void 0 ? void 0 : _$ref.call(document, textareaId);
        if (textareaElement) {
            textareaElement.focus();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: finalContainerClasses,
        dir: "auto",
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: textareaId,
                className: finalLabelClasses,
                children: [
                    label,
                    required && (requiredIndicator || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "".concat(textareaProps.disabled ? "text-neutral-400" : "text-[#B42318]", " ltr:ml-1 rtl:mr-1"),
                        children: "*"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                onClick: handleFocusOnTextAreaField,
                className: wrapperClasses,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    ref: ref,
                    id: textareaId,
                    name: name,
                    required: required,
                    rows: rows,
                    className: finalTextAreaClasses
                }, textareaProps))
            }),
            description && !error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: finalDescriptionClasses,
                children: description
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: finalErrorClasses,
                role: "alert",
                children: errorMessage
            })
        ]
    });
});
DGATextArea.displayName = "DGATextArea";
/* harmony default export */ __webpack_exports__["default"] = (DGATextArea);


/***/ }),

/***/ 87664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CleanRelativeLink": function() { return /* binding */ CleanRelativeLink; },
/* harmony export */   "buildRedirectPath": function() { return /* binding */ buildRedirectPath; },
/* harmony export */   "cleanRelativeLinkWithLocale": function() { return /* binding */ cleanRelativeLinkWithLocale; },
/* harmony export */   "extractArInternalPath": function() { return /* binding */ extractArInternalPath; },
/* harmony export */   "extractRelativePath": function() { return /* binding */ extractRelativePath; },
/* harmony export */   "extractRelativeURLPath": function() { return /* binding */ extractRelativeURLPath; },
/* harmony export */   "isExternalUrl": function() { return /* binding */ isExternalUrl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _isRtl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62009);
/* harmony import */ var lib_locale_urls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54431);
/* provided dependency */ var process = __webpack_require__(83454);




var sitecorePublicTld =  true ? ".sa" : 0;
var extractRelativePath = function(url) {
    // Remove the protocol part (e.g., 'https://')
    var relativePath = "";
    // Extract the domain part (e.g., 'moc-adc.takamulstg.com' / prod: ...takamul.sa)
    if (url) {
        relativePath = url === null || url === void 0 ? void 0 : url.split(sitecorePublicTld)[1];
    }
    if (relativePath) {
        return "https://c-admin.takamulstg.com" + relativePath;
    } else {
        return url;
    }
};
var extractRelativeURLPath = function(url) {
    // Remove the protocol part (e.g., 'https://')
    var relativePath = "";
    // Extract the domain part (e.g., 'moc-adc.takamulstg.com' / prod: ...takamul.sa)
    if (url) {
        relativePath = url === null || url === void 0 ? void 0 : url.split(sitecorePublicTld)[1];
    }
    if (url === null || url === void 0 ? void 0 : url.includes("mulhem-client.takamul.info")) {
        return process.env.MULHEM_API + relativePath;
    } else if (relativePath) {
        return "https://c-main.takamulstg.com" + relativePath;
    } else {
        return url;
    }
};
var extractArInternalPath = function(url) {
    if (url && (0,_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])()) {
        var path = url === null || url === void 0 ? void 0 : url.split(new RegExp("".concat(sitecorePublicTld.replace(".", "\\."), "/[Mm]inistries/[mM]oc/[hH]ome")))[1];
        if (path) {
            var publicPath = (0,lib_locale_urls__WEBPACK_IMPORTED_MODULE_2__/* .buildLocalePath */ .T)(lib_locale_urls__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_LOCALE */ .ZW, "/".concat((path || "").replace(/^\/+/, "")));
            return ("https://c-main.takamulstg.com" || 0).replace(/\/$/, "") + publicPath;
        } else {
            return url;
        }
    } else return url;
};
function isExternalUrl(url) {
    var sitecoreHost = "https://c-main.takamulstg.com";
    var sitecoreHost2 = "https://c-admin.takamulstg.com";
    if (!url) return false;
    // Consider URLs starting with the Sitecore host as relative (even though technically absolute)
    if (sitecoreHost && ((url === null || url === void 0 ? void 0 : url.startsWith(sitecoreHost)) || (url === null || url === void 0 ? void 0 : url.startsWith(sitecoreHost2)))) {
        return false;
    }
    // Normal check for absolute URLs
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
/**
 * Same path logic as CleanRelativeLink but pure — safe for click handlers and non-React code.
 * CleanRelativeLink must not be passed as a callback (it calls useRouter); use this with router.locale instead.
 */ function cleanRelativeLinkWithLocale(url, locale) {
    var loc = locale || lib_locale_urls__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_LOCALE */ .ZW;
    if (url) {
        var link = "";
        var fixedPart = "/ministries/moc/home";
        if (url === null || url === void 0 ? void 0 : url.toLowerCase().includes(fixedPart)) {
            var lowerUrl = url.toLowerCase();
            var fixedPartIndex = lowerUrl.indexOf(fixedPart);
            if (fixedPartIndex !== -1) {
                var afterFixedPart = url.substring(fixedPartIndex + fixedPart.length);
                return afterFixedPart || "/";
            }
        }
        if (isExternalUrl(url)) {
            return url;
        }
        try {
            var parsedUrl = new URL(url);
            var pathWithoutLocale = (0,lib_locale_urls__WEBPACK_IMPORTED_MODULE_2__/* .stripLocalePrefix */ .Iv)(parsedUrl.pathname);
            var ref;
            link = (0,lib_locale_urls__WEBPACK_IMPORTED_MODULE_2__/* .buildLocalePath */ .T)(loc, pathWithoutLocale) + ((ref = parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.search) !== null && ref !== void 0 ? ref : "");
        } catch (e) {
            if (!(url === null || url === void 0 ? void 0 : url.startsWith("/en/")) && !(url === null || url === void 0 ? void 0 : url.startsWith("/ar/")) && !(url === null || url === void 0 ? void 0 : url.startsWith("/zh/")) && !(url === null || url === void 0 ? void 0 : url.startsWith("/ko/"))) {
                var normalizedUrl = (url === null || url === void 0 ? void 0 : url.startsWith("/")) ? url.slice(1) : url;
                var pathWithoutLocale1 = normalizedUrl ? "/".concat(normalizedUrl) : "/";
                return (0,lib_locale_urls__WEBPACK_IMPORTED_MODULE_2__/* .buildLocalePath */ .T)(loc, pathWithoutLocale1);
            } else {
                return (0,lib_locale_urls__WEBPACK_IMPORTED_MODULE_2__/* .buildLocalePath */ .T)(loc, (0,lib_locale_urls__WEBPACK_IMPORTED_MODULE_2__/* .stripLocalePrefix */ .Iv)(url.split("?")[0]));
            }
        }
        return link;
    }
    return "";
}
function CleanRelativeLink(url) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    return cleanRelativeLinkWithLocale(url, router.locale);
}
/**
 * Builds a clean path by replacing the locale prefix and preserving query and hash.
 * @param asPath - The original `router.asPath` string
 * @param currentLocale - The current locale (to be replaced)
 * @returns The cleaned path string without the locale prefix
 */ function buildRedirectPath(asPath, currentLocale) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(asPath.split("?"), 2), pathAndHash = ref[0], tmp = ref[1], queryString = tmp === void 0 ? "" : tmp;
    var hashIndex = pathAndHash.indexOf("#");
    var pathname = hashIndex >= 0 ? pathAndHash.slice(0, hashIndex) : pathAndHash;
    var hash = hashIndex >= 0 ? pathAndHash.slice(hashIndex) : "";
    var cleanedPath = (0,lib_locale_urls__WEBPACK_IMPORTED_MODULE_2__/* .stripLocalePrefix */ .Iv)(pathname);
    var newPath = "".concat(cleanedPath).concat(queryString ? "?".concat(queryString) : "").concat(hash);
    return newPath;
}



/***/ }),

/***/ 14662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64857);
/* harmony import */ var _icons_arrow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18106);
/* eslint-disable @typescript-eslint/no-explicit-any */ 





var DropDownButton = function(param) {
    var customIcon = param.customIcon, buttonTitle = param.buttonTitle, listOptions = param.listOptions, listOption = param.listOption, setListOption = param.setListOption, customDropdownPanel = param.customDropdownPanel, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, listButtonCustomClasses = param.listButtonCustomClasses;
    var ref, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative ".concat(fullWidth ? "!max-w-none" : "max-w-[121px] md:max-w-[250px]", " w-full"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Listbox */ .R, {
            value: listOption,
            onChange: setListOption,
            children: function(param) {
                var open = param.open;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListboxButton, {
                            open: open,
                            buttonTitle: buttonTitle,
                            listOptionTitle: (listOption === null || listOption === void 0 ? void 0 : listOption.title) || "",
                            customIcon: customIcon,
                            listButtonCustomClasses: listButtonCustomClasses
                        }),
                        (listOptions && (listOptions === null || listOptions === void 0 ? void 0 : listOptions.length) > 0 || customDropdownPanel) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Listbox.Options */ .R.Options, {
                            className: "p-2 absolute top-full left-0 rtl:left-auto right-auto  z-[1000] border border-neutral-400 rounded space-y-1 bg-white ".concat(customDropdownPanel ? "w-full !max-w-[200px]" : "min-w-fit w-full border-neutral-300 p-2 space-y-1", " mt-1 animate-slide-in !overflow-y-auto overflow-x-hidden max-h-[300px] h-md:max-h-[400px]"),
                            style: {
                                boxShadow: "0px 24px 48px -12px #1018282E"
                            },
                            children: customDropdownPanel ? customDropdownPanel : listOptions === null || listOptions === void 0 ? void 0 : listOptions.map(function(option, index) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Listbox.Option */ .R.Option, {
                                    value: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, option), {
                                        id: (ref = option === null || option === void 0 ? void 0 : option.id) !== null && ref !== void 0 ? ref : "",
                                        title: (ref1 = option === null || option === void 0 ? void 0 : option.title) !== null && ref1 !== void 0 ? ref1 : ""
                                    }),
                                    children: function(param) {
                                        var active = param.active;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full max-w-[200px] flex justify-between gap-2 items-center truncate p-3 text-primary-1000 text-sm hover:!bg-neutral-100 rounded cursor-pointer transition-colors  ".concat(active || (option === null || option === void 0 ? void 0 : option.id) === (listOption === null || listOption === void 0 ? void 0 : listOption.id) ? " bg-neutral-200" : ""),
                                            children: [
                                                option === null || option === void 0 ? void 0 : option.title,
                                                (option === null || option === void 0 ? void 0 : option.id) === (listOption === null || listOption === void 0 ? void 0 : listOption.id) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    width: "24",
                                                    height: "24",
                                                    viewBox: "0 0 16 17",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    "aria-hidden": true,
                                                    focusable: "false",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            d: "M0 2.5C0 1.39543 0.895431 0.5 2 0.5H14C15.1046 0.5 16 1.39543 16 2.5V14.5C16 15.6046 15.1046 16.5 14 16.5H2C0.895431 16.5 0 15.6046 0 14.5V2.5Z",
                                                            fill: "transparent"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M11.7296 5.5233C12.0901 5.88378 12.0901 6.46825 11.7296 6.82874L7.49887 11.0596C7.32576 11.2327 7.09097 11.3299 6.84615 11.3299C6.60134 11.3299 6.36655 11.2327 6.19344 11.0596L4.27036 9.13646C3.90988 8.77597 3.90988 8.1915 4.27036 7.83101C4.63085 7.47053 5.21531 7.47053 5.57579 7.83101L6.84615 9.10139L10.4242 5.5233C10.7847 5.16281 11.3692 5.16281 11.7296 5.5233Z",
                                                            fill: "currentColor"
                                                        })
                                                    ]
                                                }) : ""
                                            ]
                                        });
                                    }
                                }, (option === null || option === void 0 ? void 0 : option.id) || index);
                            })
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(DropDownButton));
var ListboxButton = function(param) {
    var open = param.open, buttonTitle = param.buttonTitle, listOptionTitle = param.listOptionTitle, customIcon = param.customIcon, listButtonCustomClasses = param.listButtonCustomClasses;
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isFocused = ref[0], setIsFocused = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!open && buttonRef.current) {
            buttonRef.current.blur();
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Listbox.Button */ .R.Button, {
        onFocus: function() {
            return setIsFocused(true);
        },
        onBlur: function() {
            return setIsFocused(false);
        },
        className: "\n                relative flex items-center justify-between gap-2\n                w-full px-5 py-[5px] rounded\n                overflow-hidden !bg-white transition-colors\n                  active:bg-neutral-200\n\n                after:content-[''] after:absolute after:bottom-0 after:left-1/2\n                after:w-full after:h-0.5 after:bg-neutral-800\n                after:origin-center after:transition-transform after:duration-300\n                after:ease-in-out after:rounded-b-sm after:pointer-events-none\n                after:-translate-x-1/2\n                border border-neutral-400 hover:border-neutral-500\n\n                ".concat(open ? "!bg-transparent border-neutral-400 after:scale-x-100 " : "bg-neutral-100 after:scale-x-0", "\n                ").concat(!open && isFocused ? "after:scale-x-100" : "", "\n                ").concat(listButtonCustomClasses || "", "\n            "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-xs md:text-sm text-gray-900 truncate",
                children: buttonTitle && !listOptionTitle ? buttonTitle : listOptionTitle
            }),
            customIcon ? customIcon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_arrow__WEBPACK_IMPORTED_MODULE_2__["default"], {
                className: "min-w-[20px] min-h-[20px] md:min-w-[24px] md:min-h-[24px] ".concat(open ? "rotate-180" : "", " transition-transform"),
                "aria-label": "",
                "aria-hidden": true
            })
        ]
    });
};


/***/ }),

/***/ 86020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getPdfPath": function() { return /* binding */ getPdfPath; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46616);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53597);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72591);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63651);
/* eslint-disable @typescript-eslint/no-explicit-any */ 



// Extract only the path from PDF URL (remove domain)
var getPdfPath = function(url) {
    if (!url) return "";
    try {
        var urlObj = new URL(url);
        return urlObj.pathname + urlObj.search + urlObj.hash;
    } catch (e) {
        // If URL parsing fails, check if it already starts with /
        if (url.startsWith("/")) {
            return url;
        }
        // Otherwise, try to extract path after domain
        var match = url.match(/\/\/[^\/]+(\/.*)$/);
        return match ? match[1] : url;
    }
};
var FileDetailComponent = function(param) {
    var bannerTitle = param.bannerTitle, publishDateText = param.publishDateText, publishedDate = param.publishedDate, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale, shareText = param.shareText, shareUrl = param.shareUrl, previewBtnText = param.previewBtnText, downloadBtnText = param.downloadBtnText, pdfUrl = param.pdfUrl, fileSrc = param.fileSrc, fileName = param.fileName, fileDisplayName = param.fileDisplayName, onPreviewClick = param.onPreviewClick, onDownloadClick = param.onDownloadClick;
    // Date formatting
    var formattedPublishedDate = publishedDate ? function() {
        var date = moment__WEBPACK_IMPORTED_MODULE_1___default()(publishedDate);
        return "".concat(date.locale("en").format("D"), " ").concat(date.locale(locale === "ar" ? "ar-ly" : locale || "en").format("MMM"), " ").concat(date.locale("en").format("YYYY"));
    }() : null;
    var downloadUrl = fileSrc ? getPdfPath(fileSrc) : "";
    var processedPdfUrl = pdfUrl ? getPdfPath(pdfUrl) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative z-10 lg:max-w-[400px] lg:min-w-[300px] w-full lg:flex-shrink-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "animate-top-dga flex flex-col gap-5 bg-white rounded-2xl p-6 border border-neutral-300 lg:mt-20 mt-0 mb-10",
            children: [
                bannerTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-[22px] lg:text-[16px] font-bold text-neutral-800",
                    children: bannerTitle
                }),
                formattedPublishedDate && publishDateText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col gap-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-start gap-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/Icons/calendar.svg",
                                alt: "Calendar",
                                className: "w-6 h-7 flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[16px] font-bold text-neutral-800",
                                        children: publishDateText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[16px] text-primary-600",
                                        children: formattedPublishedDate
                                    })
                                ]
                            })
                        ]
                    })
                }),
                shareText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: "text-[22px] lg:text-[16px] font-bold text-neutral-800",
                            children: shareText
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex gap-1 mt-1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    url: shareUrl,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-fit flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/Icons/twitter-x-sharemodal.svg",
                                            alt: "Twitter/X",
                                            className: "w-8 h-8"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    url: shareUrl,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-fit flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/Icons/linkedin-sharemodal.svg",
                                            alt: "LinkedIn",
                                            className: "w-8 h-8"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    url: shareUrl,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-fit flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/Icons/instagram.svg",
                                            alt: "Instagram",
                                            className: "w-8 h-8"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                (processedPdfUrl || fileSrc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-row gap-3 border-t pt-6 border-neutral-400/50",
                    children: [
                        processedPdfUrl && previewBtnText && onPreviewClick && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_2__.DGAButton, {
                            className: "!w-fit",
                            type: "button",
                            onClick: onPreviewClick,
                            buttonContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/Icons/eye.svg",
                                        alt: "Preview",
                                        className: "w-6 h-6"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: previewBtnText
                                    })
                                ]
                            }),
                            size: "md",
                            variant: "primary"
                        }),
                        fileSrc && downloadBtnText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: downloadUrl,
                            download: fileName || fileDisplayName,
                            onClick: function(e) {
                                onDownloadClick === null || onDownloadClick === void 0 ? void 0 : onDownloadClick(e, fileName || fileDisplayName || "");
                                e.stopPropagation();
                            },
                            className: (0,components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_2__.getDgAButtonClassNames)("secondarySolid", "md", "!w-fit"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/Icons/download.svg",
                                        alt: "",
                                        "aria-hidden": true,
                                        className: "w-6 h-6"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: downloadBtnText
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FileDetailComponent);


/***/ }),

/***/ 71571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16606);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Shared_dga_breadcrumbs_DGABreadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39432);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87664);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62009);
/* eslint-disable @typescript-eslint/no-explicit-any */ 






var FileDetailLayout = function(param) {
    var _breadcrumbsItems = param.breadcrumbsItems, breadcrumbsItems = _breadcrumbsItems === void 0 ? [] : _breadcrumbsItems, title = param.title, imageSrc = param.imageSrc, imageAlt = param.imageAlt, description = param.description;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isImageLoading = ref[0], setIsImageLoading = ref[1];
    var handleImageLoad = function() {
        setIsImageLoading(false);
    };
    var handleImageError = function() {
        setIsImageLoading(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex flex-col gap-20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "animate-top-dga relative z-10 flex flex-col gap-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-0 bg-primary-25 absolute top-0 left-0 right-0 h-full w-[200%] ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_5__["default"])() ? "translate-x-[10%]" : "-translate-x-[10%]")
                    }),
                    breadcrumbsItems.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative z-10 pt-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_breadcrumbs_DGABreadcrumbs__WEBPACK_IMPORTED_MODULE_3__.DGABreadcrumbs, {
                            links: breadcrumbsItems.map(function(item) {
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
                                return {
                                    id: (item === null || item === void 0 ? void 0 : item.id) || "",
                                    label: (item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.LinkText) === null || ref1 === void 0 ? void 0 : ref1.value) || "",
                                    link: (item === null || item === void 0 ? void 0 : (ref2 = item.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.LinkUrl) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.href) ? {
                                        href: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_4__.CleanRelativeLink)(item === null || item === void 0 ? void 0 : (ref5 = item.fields) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.LinkUrl) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.value) === null || ref7 === void 0 ? void 0 : ref7.href),
                                        target: (item === null || item === void 0 ? void 0 : (ref8 = item.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.LinkUrl) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.value) === null || ref10 === void 0 ? void 0 : ref10.target) || "_self",
                                        querystring: ""
                                    } : null
                                };
                            })
                        })
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "relative z-10 text-[30px] lg:text-[35px] 2xl:text-[40px] font-bold text-primary-1000 mb-6",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 w-full",
                children: [
                    imageSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative w-full mb-6 min-h-[429px]",
                        children: [
                            isImageLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "inset-0 bg-gray-200 animate-pulse rounded-lg h-full w-full"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_4__.extractRelativePath)(imageSrc),
                                alt: imageAlt || title || "File detail image",
                                layout: "fill",
                                objectFit: "cover",
                                className: "rounded-lg transition-opacity duration-300 ".concat(isImageLoading ? "opacity-0" : "opacity-100"),
                                unoptimized: true,
                                onLoad: handleImageLoad,
                                onError: handleImageError
                            })
                        ]
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-[16px] text-primary-1000 text-justify mb-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .RichText */ .H, {
                            field: {
                                value: description
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FileDetailLayout);


/***/ }),

/***/ 32979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var google_map_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76725);


var Marker = function(param) {
    var lat = param.lat, lng = param.lng, text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute cursor-pointer z-50",
        style: {
            transform: "translate(-50%, -100%)"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "45",
            height: "30",
            viewBox: "0 0 45 30",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "drop-shadow-md",
            "aria-hidden": true,
            focusable: "false",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                    opacity: "0.3",
                    cx: "22.4903",
                    cy: "24",
                    rx: "22.4747",
                    ry: "6",
                    fill: "#EB5A3C"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M32.4176 10C32.4176 17 23.0096 23 23.0096 23C23.0096 23 13.6016 17 13.6016 10C13.6016 7.61305 14.5928 5.32387 16.3571 3.63604C18.1214 1.94821 20.5144 1 23.0096 1C25.5047 1 27.8977 1.94821 29.662 3.63604C31.4264 5.32387 32.4176 7.61305 32.4176 10Z",
                    stroke: "#EB5A3C",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M23.011 13C24.743 13 26.147 11.6569 26.147 10C26.147 8.34315 24.743 7 23.011 7C21.279 7 19.875 8.34315 19.875 10C19.875 11.6569 21.279 13 23.011 13Z",
                    stroke: "#EB5A3C",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var GoogleMap = function(param) {
    var coordinates = param.coordinates, height = param.height, _marker = param.marker, marker = _marker === void 0 ? false : _marker;
    var renderMarker = function(map, maps) {
        new maps.Marker({
            position: {
                lat: coordinates.lat,
                lng: coordinates.lng
            },
            map: map
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            height: height,
            width: "100%"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(google_map_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            bootstrapURLKeys: {
                key: "AIzaSyDEMxc9UdpMitCAklS2RsMyD5rjhngRznk" + ""
            },
            defaultCenter: coordinates,
            defaultZoom: 9,
            options: {
                disableDefaultUI: true
            },
            yesIWantToUseGoogleMapApiInternals: true,
            children: marker && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Marker, {
                lat: coordinates === null || coordinates === void 0 ? void 0 : coordinates.lat,
                lng: coordinates === null || coordinates === void 0 ? void 0 : coordinates.lng
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (GoogleMap);


/***/ }),

/***/ 2259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31230);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16748);
/* eslint-disable @typescript-eslint/no-explicit-any */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query HandLink($id: String!, $lang: String!) {\n    item(path: $id, language: $lang) {\n      ... on PageNavigationLink {\n        id\n        linkField: field(name: "Url") {\n          jss\n        }\n      }\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var HAND_LINK_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps)(_templateObject());
var HAND_LINK_ID = "{560D40A5-53CD-449C-A667-0E36BD29353B}";
function restructureUrl(url, linktype) {
    if (!url) return "";
    if (linktype === "internal") {
        var lowerUrl = url.toLowerCase();
        var modulesIndex = lowerUrl.indexOf("/modules");
        if (modulesIndex !== -1) return url.substring(modulesIndex);
        return "";
    }
    return url;
}
var HandLink = function(param) {
    var locale = param.locale;
    var ref, ref1, ref2;
    var ref3 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a)(HAND_LINK_QUERY, {
        variables: {
            id: HAND_LINK_ID,
            lang: locale || "ar"
        },
        skip: !locale
    }), handLinkData = ref3.data;
    var handLinkValue = handLinkData === null || handLinkData === void 0 ? void 0 : (ref = handLinkData.item) === null || ref === void 0 ? void 0 : (ref1 = ref.linkField) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.jss) === null || ref2 === void 0 ? void 0 : ref2.value;
    var handLink = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (!handLinkValue) return null;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, handLinkValue), {
            href: restructureUrl(handLinkValue.href, handLinkValue.linktype) || "/",
            target: handLinkValue.target || "_self"
        });
    }, [
        handLinkValue
    ]);
    if (!(handLink === null || handLink === void 0 ? void 0 : handLink.href)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("nav", {
        "aria-label": locale === "ar" ? "دعم إتاحة الوصول" : locale === "zh" ? "无障碍支持" : locale === "ko" ? "접근성 지원" : "Accessibility support",
        className: "fixed bottom-[107px] left-[6px] z-50 cursor-pointer",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: handLink.href,
            legacyBehavior: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                target: handLink.target,
                rel: "noopener noreferrer",
                "aria-label": locale === "ar" ? "رابط الدعم والمساعدة" : "Accessibility support link",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: "/Icons/hand.svg",
                    width: 50,
                    height: 50,
                    alt: "",
                    "aria-hidden": true
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HandLink);


/***/ }),

/***/ 46250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HeroPlayer": function() { return /* binding */ HeroPlayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16606);
/* harmony import */ var components_Feature_Custom_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17163);




var HeroPlayer = function(param) {
    var src = param.src, poster = param.poster, isPaused = param.isPaused, title = param.title, description = param.description, buttonText = param.buttonText, buttonLink = param.buttonLink, buttonLinkType = param.buttonLinkType, buttonLinkTarget = param.buttonLinkTarget, isMobile = param.isMobile, locale = param.locale, lang = param.lang, index = param.index;
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    var playRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var pauseRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setMounted(true);
    });
    // mounted && document.querySelectorAll('.hero-vid').forEach(vid => vid.volume = 0.2)
    mounted && document.querySelectorAll(".hero-vid").forEach(function(vid) {
        vid.removeAttribute("controls");
        vid.setAttribute("muted", "true");
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-full absolute top-0 z-10 left-0 bg-black opacity-10"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                className: "hero-vid w-full h-full object-cover absolute -z-20",
                ref: videoRef,
                src: src,
                poster: poster,
                preload: index === 0 ? "auto" : "metadata",
                loop: true,
                muted: true,
                autoPlay: true,
                controls: false,
                "webkit-playsinline": true,
                playsInline: true,
                "data-swiper-parallax": isMobile ? index == 0 ? "" : "300" : "0",
                "aria-label": title || "Hero video",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("track", {
                    kind: "captions"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "responsive m-auto text-start relative md-hero-height-mt\n        flex flex-col justify-end min-h-[70vh] md:min-h-screen w-full z-[50] bottom-[10%] transition-opacity md:justify-center md:bottom-0\n         ".concat(locale == lang ? "rtl" : ""),
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-[32px] md:pb-4 md:text-3brand h-md:lg:text-2brand md:max-w-[60%] lg:max-w-[50%] 2xl:max-w-[35%]",
                            "data-swiper-parallax": "-600",
                            children: title
                        })
                    }),
                    (description === null || description === void 0 ? void 0 : description.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-[18px] md:text-5brand max-w-[90%] my-2 md:my-0 md:max-w-[60%] lg:max-w-[50%] 2xl:max-w-[35%] xl:text-2xl text-justify",
                        "data-swiper-parallax": "-1500",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .RichText */ .H, {
                            field: description
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        class: "flex align-center gap-4 md:gap-8 md:mt-8",
                        "data-swiper-parallax": "-2000",
                        children: [
                             false && /*#__PURE__*/ 0,
                            buttonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex items-center mt-1 md:mt-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Feature_Custom_Button__WEBPACK_IMPORTED_MODULE_2__.Button, {
                                    classNames: "self-start hover:bg-brand-1000 hover:border-brand-1000 !text-[16px] !border-[1px] !px-4 !py-[0.7rem] h-md:md:!px-8 h-md:md:!py-4",
                                    redirect: buttonLink,
                                    text: buttonText,
                                    target: buttonLinkTarget,
                                    linktype: buttonLinkType
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 78278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getWritingDirection": function() { return /* binding */ getWritingDirection; }
/* harmony export */ });
var getWritingDirection = function(lang) {
    if (lang == "en") return "ltr";
    else if (lang == "ar") return "rtl";
};



/***/ }),

/***/ 11881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Loading = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (props === null || props === void 0 ? void 0 : props.isCardList) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "2xl:px-28 xl:px-22 md:px-8 px-3 grid grid-cols-1 md:grid-cols-2 md:gap-x-4 lg:grid-cols-3 lg:gap-x-16 gap-y-24 ".concat(props === null || props === void 0 ? void 0 : props.classes),
                children: Array.from({
                    length: props === null || props === void 0 ? void 0 : props.itemsPerPage
                }, function(index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        role: "status",
                        className: "p-4 md:max-w-sm border border-gray-200 shadow animate-pulse md:p-6  ".concat(props === null || props === void 0 ? void 0 : props.itemClasses),
                        children: [
                            !(props === null || props === void 0 ? void 0 : props.hideSVG) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex justify-center items-center mb-4 h-48 bg-gray-300",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "w-12 h-12 text-gray-200",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    fill: "currentColor",
                                    viewBox: "0 0 640 512",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-2.5 bg-gray-200 xl:w-48 w-32 mb-4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-6 bg-gray-200 mb-2.5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-2 bg-gray-200 mb-2.5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-2 bg-gray-200"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex items-center mt-4 space-x-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-8 border border-gray-200 w-full mb-2"
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            }),
            (props === null || props === void 0 ? void 0 : props.isVideoList) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "responsive flex flex-wrap md:justify-between justify-around gap-y-14 my-24",
                    children: Array.from({
                        length: props === null || props === void 0 ? void 0 : props.itemsPerPage
                    }, function(_, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            role: "status",
                            className: "flex justify-center items-center w-[45%] h-56 bg-gray-300 animate-pulse",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                className: "w-12 h-12 text-gray-200",
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-hidden": "true",
                                fill: "currentColor",
                                viewBox: "0 0 384 512",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M361 215C375.3 223.8 384 239.3 384 256C384 272.7 375.3 288.2 361 296.1L73.03 472.1C58.21 482 39.66 482.4 24.52 473.9C9.377 465.4 0 449.4 0 432V80C0 62.64 9.377 46.63 24.52 38.13C39.66 29.64 58.21 29.99 73.03 39.04L361 215z"
                                })
                            })
                        }, index);
                    })
                })
            }),
            (props === null || props === void 0 ? void 0 : props.isGallery) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "responsive grid gap-y-11 grid-cols-1 lg:grid-cols-2 lg:gap-x-14 lg:gap-y-14 my-24",
                        children: Array.from({
                            length: 2
                        }, function(_) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                role: "status",
                                className: "p-4 w-full border border-gray-200 shadow animate-pulse md:p-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex justify-center items-center mb-4 h-48 bg-gray-300",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            className: "w-12 h-12 text-gray-200",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "aria-hidden": "true",
                                            fill: "currentColor",
                                            viewBox: "0 0 640 512",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-2.5 bg-gray-200 w-48 mb-4"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-6 bg-gray-200 mb-2.5"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-2 bg-gray-200 mb-2.5"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-2 bg-gray-200"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex items-center mt-4 space-x-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "h-8 border border-gray-200 w-full mb-2"
                                            })
                                        })
                                    })
                                ]
                            }, _);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "responsive flex animate-pulse p-4 gap-4 border shadow border-gray-200 md:p-6 my-24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                role: "status",
                                className: "w-full lg:w-[80%]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex justify-center items-center mb-4 h-48 bg-gray-300",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        className: "w-12 h-12 text-gray-200",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        fill: "currentColor",
                                        viewBox: "0 0 640 512",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-11 bg-gray-200 w-48 mb-4"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-20 bg-gray-200 mb-2.5"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "responsive flex flex-row-reverse animate-pulse p-4 gap-4 border shadow border-gray-200 md:p-6 my-24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                role: "status",
                                className: "w-full lg:w-[80%]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex justify-center items-center mb-4 h-48 bg-gray-300",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        className: "w-12 h-12 text-gray-200",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        fill: "currentColor",
                                        viewBox: "0 0 384 512",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M361 215C375.3 223.8 384 239.3 384 256C384 272.7 375.3 288.2 361 296.1L73.03 472.1C58.21 482 39.66 482.4 24.52 473.9C9.377 465.4 0 449.4 0 432V80C0 62.64 9.377 46.63 24.52 38.13C39.66 29.64 58.21 29.99 73.03 39.04L361 215z"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-11 bg-gray-200 w-48 mb-4"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-20 bg-gray-200 mb-2.5"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (props === null || props === void 0 ? void 0 : props.isCalendar) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-[130px] relative grid grid-cols-7 w-full place-items-center bg-[#F2F2F2] py-10 animate-pulse gap-y-10",
                children: Array.from({
                    length: 7
                }, function(_, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[29px] h-[22px] md:w-[58px] md:h-[44px] bg-[#e4e4e4]"
                    }, index);
                })
            }),
            (props === null || props === void 0 ? void 0 : props.isImg) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                role: "status",
                className: " p-4 w-full border border-gray-200 shadow animate-pulse md:p-6  ".concat(props === null || props === void 0 ? void 0 : props.itemClasses),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center items-center mb-4 h-48 bg-gray-300",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        className: "w-12 h-12 text-gray-200",
                        xmlns: "http://www.w3.org/2000/svg",
                        "aria-hidden": "true",
                        fill: "currentColor",
                        viewBox: "0 0 640 512",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Loading);


/***/ }),

/***/ 54520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 



/**
 * MediaRenderer Component
 * 
 * Renders different media types based on the provided media object:
 * - YouTube videos: when media.value is a string (YouTube video ID)
 * - Video files: when mimeType starts with "video/"
 * - Images: for all other cases
 * 
 * @param media - Media object that can be:
 *   - Full media object: { src: "...", mimeType: "video/mp4", ... }
 *   - YouTube video: { value: "youtubeVideoId" }
 * @param className - Additional CSS classes to apply
 * @param videoProps - Additional props to pass to video element
 * @param imageStyle - Additional inline styles for image background
 */ var MediaRenderer = function(param) {
    var media = param.media, _className = param.className, className = _className === void 0 ? "" : _className, _videoProps = param.videoProps, videoProps = _videoProps === void 0 ? {} : _videoProps, _imageStyle = param.imageStyle, imageStyle = _imageStyle === void 0 ? {} : _imageStyle, _asBackground = param.asBackground, asBackground = _asBackground === void 0 ? true : _asBackground, _priority = param.priority, priority = _priority === void 0 ? false : _priority;
    // Handle nested value structure (e.g., when media.value is an object)
    var mediaValue = media === null || media === void 0 ? void 0 : media.value;
    var isValueAnObject = mediaValue && typeof mediaValue === "object" && !Array.isArray(mediaValue);
    // Extract properties - check both direct properties and nested value object
    var src = (media === null || media === void 0 ? void 0 : media.src) || (isValueAnObject ? mediaValue === null || mediaValue === void 0 ? void 0 : mediaValue.src : null) || "";
    var mimeType = (media === null || media === void 0 ? void 0 : media.mimeType) || (isValueAnObject ? mediaValue === null || mediaValue === void 0 ? void 0 : mediaValue.mimeType : null) || "";
    var extension = (media === null || media === void 0 ? void 0 : media.extension) || (isValueAnObject ? mediaValue === null || mediaValue === void 0 ? void 0 : mediaValue.extension : null) || "";
    var alt = (media === null || media === void 0 ? void 0 : media.alt) || (isValueAnObject ? mediaValue === null || mediaValue === void 0 ? void 0 : mediaValue.alt : null) || "";
    // Check if it's a YouTube video
    // YouTube: when value is a string (not an object) and there's no src/mimeType/extension
    // This handles cases like {value: "youtubeVideoId"} or {value: "12345"}
    var hasMediaProperties = !!((media === null || media === void 0 ? void 0 : media.src) || (media === null || media === void 0 ? void 0 : media.mimeType) || (media === null || media === void 0 ? void 0 : media.extension));
    var hasNestedMediaProperties = isValueAnObject && !!((mediaValue === null || mediaValue === void 0 ? void 0 : mediaValue.src) || (mediaValue === null || mediaValue === void 0 ? void 0 : mediaValue.mimeType) || (mediaValue === null || mediaValue === void 0 ? void 0 : mediaValue.extension));
    var isYouTubeVideo = typeof mediaValue === "string" && mediaValue.length > 0 && !hasMediaProperties && !hasNestedMediaProperties;
    // Check if it's a regular video file
    var isVideoFile = (mimeType === null || mimeType === void 0 ? void 0 : mimeType.startsWith("video/")) || (extension === null || extension === void 0 ? void 0 : extension.toLowerCase()) === "mp4" || (extension === null || extension === void 0 ? void 0 : extension.toLowerCase()) === "webm" || (extension === null || extension === void 0 ? void 0 : extension.toLowerCase()) === "mov";
    // YouTube video rendering
    if (isYouTubeVideo) {
        var youtubeId = typeof mediaValue === "string" ? mediaValue : "";
        var youtubeUrl = "https://www.youtube-nocookie.com/embed/".concat(youtubeId, "?autoplay=1&mute=1&loop=1&playlist=").concat(youtubeId, "&controls=0&modestbranding=1&rel=0&showinfo=0");
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute top-0 left-0 right-0 bottom-0 w-full h-full overflow-hidden -z-10 ".concat(className),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                title: "Embedded YouTube video",
                src: youtubeUrl,
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                allowFullScreen: true,
                referrerPolicy: "strict-origin-when-cross-origin",
                frameBorder: "0",
                className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                style: {
                    width: "100vw",
                    height: "56.25vw",
                    minWidth: "177.78vh",
                    minHeight: "100vh",
                    pointerEvents: "none"
                }
            })
        });
    }
    // Regular video file rendering
    if (isVideoFile && src) {
        if (asBackground) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                src: src,
                autoPlay: true,
                muted: true,
                loop: true,
                playsInline: true,
                preload: "auto"
            }, priority && {
                fetchPriority: "high"
            }), {
                className: "absolute top-0 left-0 right-0 bottom-0 w-full h-full object-cover -z-10 ".concat(className),
                "aria-label": alt || "Background video"
            }), videoProps), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("track", {
                    kind: "captions"
                })
            }));
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            src: src,
            autoPlay: true,
            muted: true,
            loop: true,
            playsInline: true,
            className: "w-full h-full object-contain z-0 ".concat(className),
            style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                width: "100%",
                height: "100%"
            }, imageStyle),
            "aria-label": alt || "Video content"
        }, videoProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("track", {
                kind: "captions"
            })
        }));
    }
    // Image rendering (default)
    if (src) {
        // Render as img tag if asBackground is false
        if (!asBackground) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: src,
                alt: alt || "Media content",
                className: "w-full h-full z-0 ".concat(className),
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    width: "100%",
                    height: "100%",
                    objectFit: "contain"
                }, imageStyle)
            });
        }
        // Render as background div (default)
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                backgroundImage: "url(".concat(src, ")")
            }, imageStyle),
            className: "absolute top-0 left-0 right-0 bottom-0 w-full h-full bg-cover bg-center -z-10 ".concat(className)
        });
    }
    // Fallback: return null if no valid media
    return null;
};
/* harmony default export */ __webpack_exports__["default"] = (MediaRenderer);


/***/ })

}]);